import { TuiInputModule } from '@taiga-ui/kit';
import { TuiSvgModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { FormControl, NgControl, ReactiveFormsModule } from '@angular/forms';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  Self,
  ViewEncapsulation,
} from '@angular/core';

import { Control, NOOP_VALUE_ACCESSOR } from '@iss/core/forms';

@Component({
  selector: 'wo-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: [ './search-field.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiSvgModule,
    ReactiveFormsModule,
  ],
})
export class SearchFieldComponent {
  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<string>>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }

  @Input() public placeholder?: string | null;
}
